(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('SystemTasksController', ["$scope", "$rootScope", "$q", "widgetSettings", "tablePaginationHelper", "defaultListConverter", "modulesManager", "modals", "columnsHelper", "systemTasksDao", "systemTasksService", function ($scope, $rootScope, $q, widgetSettings, tablePaginationHelper, defaultListConverter, modulesManager, modals, columnsHelper, systemTasksDao, systemTasksService) {
        $scope.title = '#' + JSON.stringify({
            display: 'html',
            text: '<strong>System Tasks</strong>'
        });
        $scope.refreshBtnOpt = {
            wrapClass: 'refresh-system-task-page',
            onClickedMsg: 'do-refresh-system-task-page',
            onFinishedMsg: 'done-refresh-system-task-page'
        };
        $scope.initializing = true;
        $scope.options = {
            columns: [
                {
                    id: 'id',
                    hidden: true,
                    primary: true
                },
                {
                    id: 'status',
                    text: ' ',
                    converter: 'taskStatusConverter'
                },
                {
                    id: 'type',
                    text: 'Type',
                    hidden: true
                },
                {
                    id: 'name',
                    text: 'Name',
                    converter: 'clickEventConverter',
                    converterArgs: {
                        eventName: 'view-actions-list',
                        class: 'link-like',
                        attributes: {
                            id: 'id',
                            status: 'status',
                            type: 'type',
                            name: 'name',
                            progress: 'progress',
                            actions: 'actions'
                        }
                    }
                },
                {
                    id: 'customer',
                    text: 'Customer',
                    hidden: true
                },
                {
                    id: 'progress',
                    text: 'Progress',
                    converter: 'progressConverter'
                },
                {
                    id: 'total',
                    text: 'Number of Actions',
                    hidden: true
                },
                {
                    id: 'schedule',
                    hidden: true
                },
                {
                    id: 'actions',
                    text: 'Current Task',
                    converter: 'currentActionConverter'
                },
                {
                    id: 'created',
                    text: 'Created',
                    converter: 'doubleLineDate'
                },
                {
                    id: 'updated',
                    text: 'Updated',
                    converter: 'doubleLineDate'
                },
                {
                    id: 'owner',
                    text: 'User'
                }
            ],
            options: {
                checkboxes: false,
                autoUpdate: 30000,
                defaultOrdering: {
                    columnName: 'created',
                    order: 'desc'
                }
            }
        };
        $scope.tableOptions = {
            disableTop: true,
            orderDisplayMode: 'highlight-column',
            asDivs: true,
            infinite: true,
            showWorkingIndicator: true,
            workingIndicatorDisableGui: false,
            saveState: true,
            headerOptions: { enum: { multiple: true } },
            pagination: {
                pageSize: 10,
                ordering: {}
            },
            dropdownHeader: true,
            actions: []
        };
        var currentActionConverter = function (text, columnId, columnsMap, args) {
            var actionName = 'Created';
            if (text && _(text).isArray() && text.length && columnsMap && columnsMap.progress) {
                var currentAction = text[columnsMap.progress - 1];
                actionName = currentAction.action_name || 'No action name';
            }
            var actionDetails = {
                display: 'linked-text',
                text: actionName,
                tooltip: args.tooltip
            };
            return '#' + JSON.stringify(actionDetails);
        };
        var doubleLineDate = function (text) {
            var time = moment.utc(text).local();
            return '#' + JSON.stringify({
                'display': 'text',
                'class': 'dbl-line-date-time',
                'text': time.format('HH:mm:ss')
            }) + '#' + JSON.stringify({
                'display': 'text',
                'class': 'dbl-line-date-date',
                'text': time.format('YYYY-MM-DD')
            });
        };
        var progressConverter = function (text, columnId, columnsMap) {
            return text.toString() + '/' + (columnsMap && columnsMap.total).toString();
        };
        $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
            var q = systemTasksDao.list();
            var params;
            if (args.columnsFilters) {
                params = columnsHelper.filtersToParams(args.columnsFilters);
                params.resolve = true;
                q.params(params);
            }
            return q.pagination(args.offset, args.limit).filter(args.filter).order(args.ordering.columnName, args.ordering.order).converter(defaultListConverter, function (preFetches) {
                return {
                    columns: $scope.options.columns,
                    converters: {
                        currentActionConverter: currentActionConverter,
                        doubleLineDate: doubleLineDate,
                        progressConverter: progressConverter,
                        taskStatusConverter: systemTasksService.taskStatusConverter
                    }
                };
            });
        }, function (tableModel) {
            $scope.initializing = false;
            $scope.tableModel = tableModel;
            $scope.tableOptions.infoText = 'Total tasks found: ' + $scope.tableHelper.getTotal();
        });
        $scope.$on('view-actions-list', function (event, data) {
            if (data && data.attributes && data.attributes.id) {
                systemTasksService.viewActionsTable(data.attributes);
            }
        });
        $scope.$on('do-refresh-system-task-page', function () {
            if ($scope.tableHelper) {
                $scope.tableHelper.clearSelection();
                $scope.tableHelper.reload(true, false).then(function () {
                    $rootScope.$broadcast('done-refresh-system-task-page');
                });
            }
        });
    }]);
}());